import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { Comments } from '../Models';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslationKeys } from 'ph-bhp-localization';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-ph-bhp-observe-comments',
  templateUrl: './ph-bhp-observe-comments.component.html',
  styleUrls: ['./ph-bhp-observe-comments.component.css']
})

export class PhBhpObserveCommentsComponent implements OnInit {
  @Input() isCollapsed = true;
  quickCommentIndex;
  @Input() isEdit = true;
  @Input() numberToName;
  @Input() stepNumber;
  @Input() sopid;
  @Output() childData = new EventEmitter();
  @ViewChild('userCommentFrom') userCommentFrom;
  @ViewChild('delete') delete: TemplateRef<any>;
  @Input() userData
  @Input() institutions
  stepName: String;
  userComment: string = '';
  @Input() comments: Array<Comments> = [];
  sopObserveCommentsMaxLength = 500;
  newModalRef: BsModalRef;
  quickComment: Array<any>;// = ["jewellery / wrist watch", "artificial finger nails / nail varnish", "Hand disinfection executed incorrectly", "Skin antisepsis executed incorrectly"];
  removeIndex: number;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(public service: PhBhpFeaturePackageSopobservationService, private layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public config: AppConfig) { }

  ngOnInit() {
    if (this.userData) {
      let userData: any = this.config.userData;

      this.service.getInstitutionGroupIdById(this.layoutService.institutionID).subscribe((groupId) => {
        var institutionGroupId = "0"
        if (groupId != 0) {
          institutionGroupId = `${groupId},${this.layoutService.institutionID}`;
        }

        this.service.getPredefinedCommentsForObservation(userData.country, institutionGroupId, this.layoutService.institutionID).subscribe((comments) => {
          this.quickComment = [];
          comments.forEach(comment => {
            switch (comment.commentName) {
              case 'jewellery / wrist watch':
                comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH');
                break;
              case 'artificial finger nails / nail varnish':
                comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH');
                break;
              case 'Hand disinfection executed incorrectly':
                comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED');
                break;
              case 'Skin antisepsis executed incorrectly':
                comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED');
                break;
              case 'Process interrupted':
                comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED');
                break;
            }

            if (comment.packages?.includes("1")) {
              this.quickComment.push(comment);
            }
          });
        });
      });
    }
  }

  onChanges() { }

  clickQuickComment(index, comment) {
    if (this.quickCommentIndex == index) {
      this.quickCommentIndex = undefined;
    } else {
      this.quickCommentIndex = index;
    }
  }

  stepNameNumber(index, name) {
    this.stepNumber = index + 1;
    this.stepName = name;
  }

  removeComment(index) {
    this.removeIndex = index;
    this.newModalRef = this.modalService.show(this.delete, { class: 'w-420 yes-no-modal' });
  }
  deleteComment() {
    this.comments.splice(this.removeIndex, 1)
  }
  onCommentsSubmit() {
    if (this.userCommentFrom.invalid) {
      return false;
    }

    if (this.quickCommentIndex == undefined && this.userComment.length == 0) {
      return false;
    }

    var commentType = 0
    var predefineCommentID = 0;
    if (this.quickCommentIndex != undefined) {
      predefineCommentID = this.quickComment[this.quickCommentIndex].predefinedCommentID;
      commentType = 1
    }
    var freeTextComment = this.userComment.length > 30 && !this.isEdit ? this.userComment.substring(0, 27) + "..." : this.userComment;
    this.comments.splice(0, 0, {
      freeTextComment: freeTextComment,
      commentDateTime: new Date(),
      stepName: this.stepName,
      stepNumber: this.stepNumber,
      commentType: commentType,
      predefineCommentID: predefineCommentID,
      sopid: this.sopid
    } as Comments);
    this.userComment = "";
    this.stepNumber = undefined;
    this.stepName = undefined;
    this.quickCommentIndex = undefined;
  }
  closeComments() {
    this.childData.emit({ key: "close" })
  }

  getCommentText(comment): string {
    var commentTexts = [];
    if (comment.predefineCommentID != 0) {
      commentTexts.push(this.quickComment.find(x => x.predefinedCommentID == comment.predefineCommentID).commentName);
      if (comment.freeTextComment.length > 0) {
        commentTexts.push(comment.freeTextComment);
      }
    } else {
      commentTexts.push(comment.freeTextComment);
    }
    return commentTexts.join(", ");
  }

  onCommentsKeyDown(event) {
    if (!(event.keyCode >= 48 && event.keyCode <= 57) && !(event.keyCode >= 65 && event.keyCode <= 90) && !(event.keyCode >= 96 && event.keyCode <= 105)) return;
    if (this.userComment && this.userComment.length >= 500) {
      this.layoutService.showWarning(this.layoutService.translateText('OBSERVATION.MAXIMUM_COMMENT_LENGTH'));
    }
  }
}
